// extracted by mini-css-extract-plugin
module.exports = {"details":"ingredient-details_details__aSShi","detail":"ingredient-details_detail__rYup2"};